<!-- 多选下拉框组件 -->
<template>
  <div>
    <template v-for="(vitem, index) in input">
      <div class="box">
        <el-select v-model="input[index]" :size="size" @change="change(index)"
          v-if="(input[index] != 'custom-listvalue') && (type == 'select')">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          <el-option v-if="custom != undefined" label="自定义" value="custom-listvalue"></el-option>
        </el-select>
        <el-input v-model="input[index]" v-if="type == 'input'" :size="size"></el-input>
        <el-input v-model="customData" v-if="(input[index] == 'custom-listvalue') && (type == 'select')"
          @blur="customBlur(index)" :size="size"></el-input>
        <el-button :size="size" icon="el-icon-plus" type="primary" v-if="index == (input.length - 1)"
          @click="addItem"></el-button>
        <el-button :size="size" icon="el-icon-close" type="danger" v-else @click="removeItem(index)"></el-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "",
  props: ['value', 'type', 'custom', 'size', 'options'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      customData: ""
    };
  },
  computed: {
    input: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);    // 触发
      }
    }
  },
  methods: {
    addItem() {
      this.input.push('');
    },
    change(index) {
      this.customData = "";
    },
    customBlur(index) {
      this.$set(this.input, index, this.customData);
      this.options.push({
        label: this.customData,
        value: this.customData
      });
    },
    removeItem(index) {
      this.input.splice(index, 1);
    }
  }
};
</script>
<style scoped>
.box {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>